import { Component, input, output, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { IChatMessage } from '@lb/api/mylb/interfaces';
import { MDIconComponent } from '@melodic-ui/components';
import { MarkdownModule } from 'ngx-markdown';

@Component({
	selector: 'lb-chat-message',
	standalone: true,
	imports: [MDIconComponent, MarkdownModule],
	templateUrl: './chat-message.component.html',
	styleUrl: './chat-message.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class ChatMessageComponent implements AfterViewInit {
	message = input.required<IChatMessage>();
	userInitials = input<string>('');
	retryMessage = output<string>();

	@ViewChild('messageBubble') messageBubble?: ElementRef<HTMLDivElement>;

	ngAfterViewInit(): void {
		// Add target="_blank" to all links in markdown content after render
		setTimeout(() => {
			this.processLinks();
		}, 100);
	}

	private processLinks(): void {
		if (this.messageBubble) {
			const links = this.messageBubble.nativeElement.querySelectorAll('markdown a');
			links.forEach((link) => {
				link.setAttribute('target', '_blank');
				link.setAttribute('rel', 'noopener noreferrer');
			});
		}
	}

	getFormattedTime(date: Date): string {
		const now = new Date();
		const messageDate = new Date(date);
		const diffMs = now.getTime() - messageDate.getTime();
		const diffMins = Math.floor(diffMs / 60000);

		if (diffMins < 1) return 'Just now';
		if (diffMins < 60) return `${diffMins}m ago`;

		const diffHours = Math.floor(diffMins / 60);
		if (diffHours < 24) return `${diffHours}h ago`;

		return messageDate.toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: '2-digit'
		});
	}

	isMarkdown(content: string): boolean {
		// Check if content contains markdown syntax
		return /[*_`#\[\]]/g.test(content);
	}

	linkifyText(text: string): string {
		// Regular expression to detect URLs
		const urlRegex = /(https?:\/\/[^\s]+)/g;
		return text.replace(urlRegex, (url) => {
			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});
	}

	onRetry(): void {
		const msg = this.message();
		if (msg.status === 'error') {
			this.retryMessage.emit(msg.content);
		}
	}
}
